// {
//     newsID: "6913216ee64f44985083ec7b",
//     rationale:
//       "This article discusses the digitalization of SMEs in China, which could be relevant to Brenda's interest in technology and investment, especially considering the focus on private investment. It also touches on retirement related investment.",
//     message:
//       "晏晝好，Brenda！唔阻你做嘢嘛？\n見到國家發改委講數字化轉型嘅新聞，諗起你對科技同投資都有興趣，睇下啱唔啱你！🔍\n**國家發改委：數字化轉型更突出因地制宜避免「為轉而轉」** 2025-11-11 18:17\nhttps://news.rthk.hk/rthk/ch/component/k2/1831127-20251111.htm"
//   }

import { Button, Box, Typography, Link } from '@mui/material';
import Share from '@mui/icons-material/Share';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: '#F7F7F7',
    borderRadius: '8px',
    padding: '10px',
    flex: 1,
    minWidth: 0, // Important: allows flex child to shrink below content size
    maxWidth: '100%',
    display: 'flex',
    gap: '10px',
    overflow: 'hidden',
    whiteSpace: 'normal'
  },
  message: {
    fontSize: '1.4rem',
    flex: 1,
    minWidth: 0, // Important: allows flex child to shrink below content size
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    wordBreak: 'break-all', // Breaks long URLs and words
    textAlign: 'justify'
  },
  shareButton: {
    marginLeft: 0,
    marginRight: 'auto',
    minWidth: 0,
    minHeight: 0,
    width: 24,
    height: 24
  },
  shareButtonContainer: {
    height: '100%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center'
  }
}));

export const MessageSuggestion = props => {
  const { message, link, onShare } = props;
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.message}>
        {message}
        <Link href={link} target="_blank">
          👉新聞原文
        </Link>
      </Typography>
      <Box className={classes.shareButtonContainer}>
        <Button className={classes.shareButton} onClick={onShare}>
          <Share style={{ fontSize: 20 }} color="primary" />
        </Button>
      </Box>
    </Box>
  );
};
